import React from 'react'
import { number } from 'prop-types'

function DirectCollaboration({ width = 16, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.3335 13.3335H10.6668V12.9668C10.6668 12.4779 10.4224 12.0835 9.9335 11.7835C9.44461 11.4835 8.80016
        11.33358.00016 11.3335C7.20016 11.3335 6.55572 11.4835 6.06683 11.7835C5.57794 12.0835 5.3335 12.4779 5.3335
        12.9668V13.3335ZM8.00016 10.6668C8.36683 10.6668 8.68083 10.5364 8.94216 10.2755C9.2035 10.0146 9.33394 9.70061
        9.3335 9.3335C9.33305 8.96639 9.20261 8.65261 8.94216 8.39216C8.68172 8.13172 8.36772 8.00105 8.00016
        8.00016C7.63261 7.99927 7.31883 8.12994 7.05883 8.39216C6.79883 8.65438 6.66816 8.96816 6.66683 9.3335C6.6655
        9.69883 6.79616 10.0128 7.05883 10.2755C7.3215 10.5382 7.63528 10.6686 8.00016 10.6668ZM4.00016 16.0002L2.46683
        17.5335C2.25572 17.7446 2.01394 17.7919 1.7415 17.6755C1.46905 17.5591 1.33305 17.3506 1.3335
        17.0502V6.66683C1.33356.30016 1.46416 5.98639 1.7255 5.7255C1.98683 5.46461 2.30061 5.33394 2.66683
        5.3335H13.3335C13.7002 5.3335 14.0142 5.46416 14.2755 5.7255C14.5368 5.98683 14.6673 6.30061 14.6668
        6.66683V14.6668C14.6668 15.0335 14.5364 15.3475 14.2755 15.6088C14.0146 15.8702 13.7006 16.0006 13.3335
        16.0002H4.00016Z"
        fill="#A7F6FC"
      />
    </svg>
  )
}

DirectCollaboration.propTypes = {
  width: number,
  height: number,
}

export default DirectCollaboration
